require('./overrides.scss')

export default {
  theme: {
    themes: {
      light: {
        primary: '#660033',
        accent: '#0d6efd',
        secondary: '#696969',
        success: '#4EA246',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
      dark: {
        primary: '#660033',
        accent: '#0d6efd',
        secondary: '#696969',
        success: '#4EA246',
        info: '#16B1FF',
        warning: '#FFB400',
        error: '#FF4C51',
      },
    },
  },
}
